import { Component, OnInit } from '@angular/core';
import { IEmailDetail } from '../interfaces/iemail-detail';
import { AuthService } from '../services/auth.service';
import { EmailService } from '../services/email.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
  userEmail:string ='';
  emailDetail:IEmailDetail={
    to:'',
    from:'',
    subject:'',
    message:''

  }
  constructor(private auth:AuthService, private emailService:EmailService) { }
 
  ngOnInit() {
    this.auth.getCurrentUserTest().subscribe(data=>this.userEmail=data.email);
    this.emailDetail.from=this.userEmail
  }

  sendMessage(){
     this.emailService.sendEmail(this.emailDetail).subscribe(msg=>{
      // if(msg==="SUCCESS"){
        Swal.fire("Your email has been sent to the taxpayer.")
      // }

     })
  }

}
